<template>
	<div class="row">
		<div class="col-md-3 mb-4">
			<select name="sucursal" class="sheet-input" v-model="form.sucursal">
				<option :value="null">SUCURSAL</option>
				<option v-for="sucu in profile.sucursals" :value="sucu.id">
					{{ sucu.address }}
				</option>
			</select>
		</div>
		<div class="col-md-3 mb-4">
			<input
				class="contact-input"
				type="text"
				name="name"
				v-model="form.name"
				placeholder="SU NOMBRE"
			/>
		</div>
		<div class="col-md-3 mb-4">
			<input
				class="contact-input"
				type="text"
				name="tel"
				v-model="form.phone"
				placeholder="SU TELEFONO"
			/>
		</div>
		<div class="col-md-3 mb-4">
			<input
				class="contact-input"
				type="email"
				name="email"
				v-model="form.email"
				placeholder="SU EMAIL"
			/>
		</div>
		<div class="col-12 mb-4">
			<textarea
				class="contact-input"
				name="msg"
				v-model="form.message"
				placeholder="SU MENSAJE"
			></textarea>
		</div>
		<div
			class="col-12 col-md-auto ml-md-auto d-flex justify-content-around justify-content-md-end"
		>
			<button class="contact-submit" @click.prevent="submit">
				ENVIAR POR EMAIL
			</button>
			<a
				class="contact-wa ml-1"
				target="_blank"
				:href="`https://api.whatsapp.com/send?phone=+5492235968758${message}`"
				>CONSULTE POR WHATSAPP</a
			>
		</div>
		<div class="col-auto py-2" v-if="response">
			{{ response }}
		</div>
		<div v-if="loading" class="spinner-wrap" style="top: 0; left: 0">
			<div class="spinner"></div>
		</div>
	</div>
</template>
<script>
	import Inmokey from '../../Inmokey'
	export default {
		name: 'contact',
		data() {
			return {
				loading: true,
				ok: false,
				response: '',
				form: {
					name: null,
					phone: null,
					email: null,
					message: '',
					sucursal: null
				},
				profile: null
			}
		},
		computed: {
			message() {
				return this.form.name &&
					this.form.phone &&
					this.form.email &&
					this.form.message &&
					this.form.sucursal
					? encodeURIComponent(`&text=*Nombre:* ${this.form.name}
*Tel:* ${this.form.phone}
*Email:* ${this.form.email}
*Sucursal:* ${this.profile.sucursals.reduce(
							(name, { id, address }) =>
								id == this.form.sucursal ? address : name,
							''
					  )}
${this.form.message}`)
					: ''
			}
		},
		methods: {
			submit() {
				this.response = null
				this.loading = true
				Inmokey.postMessage(this.form, e => {
					if (e.result) {
						this.response = 'Mensaje enviado.'
						this.form.name = null
						this.form.phone = null
						this.form.email = null
						this.form.message = ''
						this.form.sucursal = null
					} else {
						this.response = e.msg
					}
					this.loading = false
					this.ok = e.result
				})
			}
		},
		beforeMount() {
			Inmokey.getProfile(profile => {
				this.profile = profile
				this.loading = false
			})
		}
	}
</script>
